export default "__VITE_ASSET__KwHcjsYC__"